import React, { Component } from 'react'
import { dtLangConfig } from "../../../../config/dtLangConfig";
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import { faComment, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Like from '../../../../assets/images/like.svg';
import Dislike from '../../../../assets/images/dislike.svg';

const $ = require('jquery');

$.DataTable = require('datatables.net-bs4');

export class Table extends Component {

    componentDidMount() {
        this.$el = $(this.el)
        this.$el.DataTable({ language: dtLangConfig })
    }

    shouldComponentUpdate() {
        this.$el.DataTable().destroy();
        return true
    }

    componentDidUpdate() {
        this.$el.DataTable({ language: dtLangConfig })
    }

    componentWillUnmount() {
        this.$el.DataTable().destroy(true);
    }

    onClickEliminar(e, empresaId) {
        e.preventDefault()
        this.props.onClickEliminar(empresaId)
    }

    onClickEditar(e, empresaId) {
        e.preventDefault()
        this.props.onClickEditar(empresaId)
    }

    onClickShow(e, empresaId) {
        e.preventDefault()
        this.props.onClickEditar(empresaId)
    }

    render() {
        return (
            <div className="col-12">
                <div className="card shadow">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table id="dataTable" className="dataTable table" width="100%" cellSpacing="0" ref={el => this.el = el}>
                                <thead>
                                    <tr>
                                        <th className="text-center">Publicación</th>
                                        <th>Categoría</th>
                                        <th>Subcategoría</th>
                                        <th>Like & Dislike</th>
                                        <th className="text-center">Visitas</th>
                                        <th className="text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.from(this.props.data).map((post, index) => {
                                        return <tr key={index}>
                                        <td>
                                            {post && post.nm_titulo ? (
                                                post.nm_titulo
                                            ) : (
                                                ''
                                            )}
                                        </td>
                                        <td>
                                            {post && post.id_categoria && post.id_categoria.nm_categoria ? (
                                                post.id_categoria.nm_categoria
                                            ) : (
                                                ''
                                            )}
                                        </td>
                                        <td>
                                            {post && post.id_subcategoria && post.id_subcategoria.nm_subcategoria ? (
                                                post.id_subcategoria.nm_subcategoria
                                            ) : (
                                                ''
                                            )}
                                        </td>
                                        <td>
                                            <img src={Like} height="20" alt="" /> {post.nr_like} / <img src={Dislike} height="20" alt="" />  {post.nr_dislike} 
                                        </td>
                                        <td className="text-center">
                                            {post && post.nr_visitas}
                                        </td>
                                        <td className="text-center">
                                            {post.nr_dislike > 0 ? (
                                                    <FontAwesomeIcon 
                                                        role="button" 
                                                        tabIndex="0" 
                                                        title="Mostrar comentario" 
                                                        className="fas fa-comment mr-3 text-success"
                                                        icon={faComment} 
                                                        onClick={(e) => this.onClickShow(e, post)} 
                                                    />
                                            ) : (
                                                <FontAwesomeIcon 
                                                        role="button" 
                                                        tabIndex="0" 
                                                        title="Mostrar comentario" 
                                                        className="fas fa-comment mr-3 text-secondary disabled"
                                                        style={{"pointerEvents": "none"}}
                                                        icon={faComment} 
                                                        onClick={(e) => this.onClickShow(e, post)} 
                                                    />
                                            )}
                                            <FontAwesomeIcon 
                                                role="button" 
                                                tabIndex="0" 
                                                title="Restablecer publicación" 
                                                className="fas fa-trash text-danger" 
                                                icon={faTrash} 
                                                onClick={(e) => this.onClickEliminar(e, post)} 
                                            />
                                        </td>
                                    </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

